export default {
    en: {
        scanner: 'Scanner',
        camera: 'Camera'
    },
    uz: {
        scanner: 'Skaner',
        camera: 'Kamera'
    },
    ru: {
        scanner: 'Сканер',
        camera: 'Камера'
    }
}